import React from 'react'
import { Spinner } from 'reactstrap'
import { gql, useQuery } from '@apollo/client'
import { Query, Question } from 'generated/types'
import moment from 'moment'
import { chartColors } from 'components/charts/colors'
import RespondentsPercentageBarChart from './RespondentsPercentageBarChart'

const CUSTOM_QUESTIONS = gql`
  query CustomQuestions($tag: String!) {
    questionsByTag(tag: $tag) {
      id
      slug
      text
    }
  }
`

interface CustomQuestionChartProps {
  question: Question
}

const CustomQuestionChart: React.FC<CustomQuestionChartProps> = ({ question }) => {
  const today = moment().startOf('day')
  const mostRecentWeekStart = today.clone().subtract(7, 'days')
  const previousWeekStart = mostRecentWeekStart.clone().subtract(7, 'days')

  return (
    <RespondentsPercentageBarChart
      questionSlug={question.slug!}
      title={question.text}
      leftChartTitle="Previous Week"
      leftChartStart={previousWeekStart}
      leftChartEnd={mostRecentWeekStart}
      rightChartTitle="Most Recent Week"
      rightChartStart={mostRecentWeekStart}
      rightChartEnd={today}
      chartColors={{
        error: chartColors.bad,
        no: chartColors.bad,
        yes: chartColors.good,
      }}
      optionOrder={['yes', 'no']}
    />
  )
}

const CustomQuestionsCharts = () => {
  const customQuestions = useQuery<Query>(CUSTOM_QUESTIONS, {
    variables: {
      tag: 'custom',
    },
  })

  if (customQuestions.loading) {
    return <Spinner />
  }

  if (customQuestions.error) {
    console.error('error loading custom questions:', customQuestions.error)
    return <span>Error loading custom questions</span>
  }

  const questionCards = customQuestions.data!.questionsByTag.map((q: Question) => (
    <CustomQuestionChart key={`custom-question-${q.slug}`} question={q} />
  ))

  return <>{questionCards}</>
}

export default CustomQuestionsCharts
